import React from "react";
import { Form, FormGroup, Row, Col } from "react-bootstrap";
import SubmitControl from "../../SubmitControl";
import { labels } from "../../../../localization/labels";
import { Button } from "react-bootstrap";
import DropDown from "../../../core/DropDown/DropDown";

const CommentForm = props => (
  <div>
    <Form
      onSubmit={event => {
        event.preventDefault();
        props.handleOnClick(props.selectedMessageLogType);
      }}
    >
      <div className="right-text-div">
        <Row>
          <Col className="Label" sm="12" md="2">
            {labels.messageLogType}
          </Col>
          <Col sm="12" md="10">
            {props.messageLogTypes ? (
              <DropDown
                value={props.selectedMessageLogType}
                options={props.messageLogTypes.map(x => ({
                  value: x,
                  label: x.name
                }))}
                onChange={props.onMessageLogTypeChange}
              />
            ) : null}
          </Col>
        </Row>
      </div>
      <FormGroup controlId="comment">
        <Row>
          <Col className="Label" sm="12" md="2">
            {labels.message}
          </Col>
          <Col sm="12" md="10">
            <SubmitControl
              className="formControl"
              maxLength={2000}
              as="textarea"
              rows="3"
              placeholder={labels.commentBox}
              multiline
              name="comment"
              variant="field"
              value={props.comment}
              onChange={props.onCommentChange}
            ></SubmitControl>
          </Col>
        </Row>
      </FormGroup>
      <Row>
        <Col SM="12">
          <div className="messageSendButton">
            <Button onClick={props.handleOnClick} disabled={!props.isValid()}>
              {labels.sendMessage}
            </Button>
          </div>
        </Col>
      </Row>
    </Form>
    <br />
  </div>
);

export default CommentForm;
